// extracted by mini-css-extract-plugin
export default {"errorWrap":"errorpage_errorWrap__mIbbl"};